/**
 * @module containers/introduction-page
 * @description Barrel export for IntroductionPage container
 */

export { IntroductionPage } from './introduction-page';
